/* eslint-disable @angular-eslint/component-class-suffix */
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, AfterViewInit, ViewEncapsulation} from '@angular/core';
import { LowerCasePipe, NgClass, DatePipe } from '@angular/common';
import {Router} from '@angular/router';

import {UserService} from '../../Services/user.service';
import {ToolsBoxService} from '../../Services/tools.service';
import {FirstLetterPipe} from '../../Pipes/firstletter.pipe';
import {CalendarEventHolder} from '../../Models/Holders/calendareventholder.model';
import { Bind } from 'primeng/bind';
import { Tabs, TabList, Tab, TabPanels, TabPanel } from 'primeng/tabs';
import { Ripple } from 'primeng/ripple';
import { CalendarComponent } from '../CalendarComponent/calendar.component';
import { OverviewComponent } from '../Overview/overview.component';
import { JustificationModalComponent } from '../../Modals/justificationmodal.component';
import { TrigrammePipe } from '../../Pipes/trigramme.pipe';

@Component({
    selector: 'timeManagement',
    styleUrls: ['timemanagement.component.css'],
    templateUrl: 'timemanagement.component.html',
    imports: [Bind, Tabs, TabList, Ripple, Tab, TabPanels, TabPanel, CalendarComponent, OverviewComponent, NgClass, JustificationModalComponent, DatePipe, TrigrammePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimeManagement implements AfterViewInit {
  //justificationModal
  justificationModalTitle: string;
  justificationModalOpened = false;
  currentEvent: CalendarEventHolder = new CalendarEventHolder();
  pendingEvents: CalendarEventHolder[] = [];

  //Notification
  alertType: string;
  alertMessage: string;

  //Test
  displayedTab: number;

  constructor(private userService: UserService, private toolsBoxService: ToolsBoxService, private router: Router, private _elRef: ElementRef, private cdr: ChangeDetectorRef) {
  }

  ngAfterViewInit() {
    this.toolsBoxService.changeHeaderName("Time Management");
    this.toolsBoxService.tellChildContainsTabs(this.isAdmin());
  }

  //When the first tab is displayed, we retrieve the list of user's Events
  //When the second tab is displayed, we retrieve the list of pending Events
  onTabChange(value: any) {
    this.pendingEvents = [];
    if (value === 2) {
      this.displayedTab = 2;
      this.getPendingEventList();
    } else if (value === 1) {
      this.displayedTab = 1;
    } else if (value === 0) {
      this.displayedTab = 0;
    }

    if (document.getElementById('body-content') !== null) {
      document.getElementById('body-content').scrollTop = 0;
    }
  }


  //initialization of the second tab (ADMIN profile)
  getPendingEventList = () => {
    this.pendingEvents = [];
    this.toolsBoxService.tellActionIsInProgress(true);
    this.userService.getPendingRequest().subscribe(
      (listEventJSON: CalendarEventHolder[]) => {
        this.pendingEvents = listEventJSON;
        this.toolsBoxService.tellActionIsInProgress(false);
        this.cdr.markForCheck();
      },
      (err) => {
        this.toolsBoxService.tellActionIsInProgress(false);
        this.router.navigate(["Error", {errMessage: err.error}]);
      }
    );
  }


  getStyleForAvatar = (userName: string): string => {
    const firstLetterPipe = new FirstLetterPipe();
    return "user-first-initial-" + firstLetterPipe.transform(userName);
  }

  getStyleForRequest = (eventType: string): string => {
    const lowerCasePipe = new LowerCasePipe();
    return "list-group-item-event event-" + lowerCasePipe.transform(eventType);
  }
  getLabelForRequest = (eventStatus: string): string => {
    if (eventStatus === ('PENDING')) {
      return 'requested';
    } else if (eventStatus === ('CORRECTED')) {
      return 'corrected';
    } else if (eventStatus === ('DEL_REQUESTED')) {
      return 'deleted';
    }
  }
  //Tabs are only displayed if the current user has ADMIN profile
  isAdmin = (): boolean => {
    return this.toolsBoxService.isAdmin();
  }

  //Tabs are only displayed if the current user has MANAGER profile
  isManager = (): boolean => {
    return this.toolsBoxService.isManager();
  }

  isPastEvent = (startDate: string) => {
    return (Date.parse(startDate) < Date.now());
  }

  manageEvent = (mode: string, eventId: number) => {
    this.currentEvent.eventId = eventId;
    this.currentEvent.eventStatus = mode;
    switch (mode) {
      case "VALIDATED":
        // Admin
        this.justificationModalTitle = "Accept request";
        this.currentEvent.eventUpdDesc = "Request validated by " + this.toolsBoxService.getStoredUserLogin();
        break;
      case "REFUSED":
        // Admin
        this.justificationModalTitle = "Reject request";
        this.currentEvent.eventUpdDesc = "Request rejected by " + this.toolsBoxService.getStoredUserLogin();
        break;
      default: 
    }
    //Then open the confirmation box
    this.justificationModalOpened = true;
  }

  //Manage the value returned by the user modal
  handleCloseEvent(mode: any) {

    this.justificationModalOpened = false;

    if (mode === 'SEND') {
      this.toolsBoxService.tellActionIsInProgress(true);
      //Sending event to be validated/rejected by the ADMIN
      const $returnSubs = this.userService.manageRequest(this.currentEvent).subscribe(
        (data) => {
          this.toolsBoxService.tellActionIsInProgress(false);
          this.show();
          this.cdr.markForCheck();
        },
        (err) => {
          this.toolsBoxService.tellActionIsInProgress(false);
          this.router.navigate(["Error", {errMessage: err.message }]);
        }
      )
    }
  }

  //Display the notification toast, refresh Events lists and close modals
  show() {
    this.alertType = 'success';
    this.alertMessage = 'Your update has been sent';
    if (this.isAdmin())
      this.getPendingEventList();
    this.justificationModalOpened = false;
    this.toolsBoxService.tellActionIsInProgress(false);
  }

  getEventLabel = (code: string) :  string => {
    return this.toolsBoxService.eventLabels()[code];
  }
}
